import {
    usePostOngewensteGebeurtenis,
    usePostTVSM,
    useRefetchDossierDetailsOnCreate,
    useScenarioStore,
} from "@/entities/ongewenste-gebeurtenis/debug.ts";
import OG1250286 from "@/scenarios/1250286.json";
import OG1250572 from "@/scenarios/1250572.json";
import OG1258880 from "@/scenarios/1258880.json";
import OG1259742 from "@/scenarios/1259742.json";
import OG1263237 from "@/scenarios/1263237.json";
import OG1263478 from "@/scenarios/1263478.json";
import OG1263602 from "@/scenarios/1263602.json";
import OG1265379 from "@/scenarios/1265379.json";
import OG1266358 from "@/scenarios/1266358.json";
import OG9999991 from "@/scenarios/9999991.json"; // VSM testscenario
import { Button, Container, InfoTooltip, Separated } from "@/shared/components";
import { ScenarioAfhandeling } from "./scenario-afhandeling.tsx";
import { Scenario, ScenarioStap } from "./types";
import { adjustOngewensteGebeurtenisTimesAndMeldingId, adjustTvsmDossierId } from "./utils";
// we know better...
const scenarios = [
    OG1250286,
    OG1250572,
    OG1258880,
    OG1259742,
    OG1263237,
    OG1263478,
    OG1263602,
    OG1265379,
    OG1266358,
    OG9999991,
] as unknown as Scenario[];

export default function Scenarios() {
    const postOngewensteGebeurtenis = usePostOngewensteGebeurtenis();
    const postTvsm = usePostTVSM();
    const addOngewensteGebeurtenis = useScenarioStore((s) => s.addOngewensteGebeurtenis);
    const reset = useScenarioStore((s) => s.reset);
    useRefetchDossierDetailsOnCreate();

    const createNewOgForScenario = (scenarioId: string, scenarioStap: ScenarioStap) => {
        const [og, logistiekeAfhandelingId] = adjustOngewensteGebeurtenisTimesAndMeldingId(scenarioStap);
        addOngewensteGebeurtenis(scenarioId, og.incident.melding.meldingId);
        postOngewensteGebeurtenis.mutate(og);
        if (scenarioStap.vsm) {
            const tvsm = adjustTvsmDossierId(scenarioStap.vsm, logistiekeAfhandelingId);
            postTvsm.mutate(tvsm);
        }
    };

    return (
        <Container fluid>
            <div className="py-6">
                <div className="mb-6 flex items-center justify-between">
                    <div className="flex w-full flex-row items-center justify-between">
                        <h1 className="text-xxl text-content-emphasis font-bold">Scenarios</h1>
                        <Button variant="tertiary" icon="refresh" onClick={reset}>
                            Reset scenarios
                        </Button>
                    </div>
                </div>
                <div className="grid gap-8">
                    <Separated>
                        {scenarios.map((scenario, index) => (
                            <div key={scenario.id} className="flex flex-col gap-4">
                                <div className="flex flex-row justify-between">
                                    <h2 className="text-l flex gap-1 align-baseline font-medium">
                                        Scenario {index + 1}: {scenario.naam} [{scenario.id}]
                                        <InfoTooltip className="grid max-h-[400px] min-w-120 gap-2 overflow-y-scroll">
                                            {scenario.stappen.map((stap) => (
                                                <span className="text-s font-normal">
                                                    Stap: {stap.volgnummer}: {stap.beschrijving}
                                                </span>
                                            ))}
                                        </InfoTooltip>
                                    </h2>
                                    <Button
                                        variant="secondary"
                                        icon="plus-circle"
                                        onClick={() => createNewOgForScenario(scenario.id, scenario.stappen[0])}
                                    >
                                        OG Scenario {index + 1} toevoegen
                                    </Button>
                                </div>
                                <ScenarioAfhandeling scenario={scenario} scenarioNummer={index + 1} />
                            </div>
                        ))}
                    </Separated>
                </div>
            </div>
        </Container>
    );
}
